export default {
    dashboardGreetingTitle: "Bonjour {{name}}, bienvenue sur LinguaScore",
    dashboardGreetingDescription: "Suivez votre progression en langues et poursuivez votre parcours.",
    averageScoreLabel: "Score moyen",
    recentResultsSectionTitle: "Vos résultats récents",
    footerDisclaimer: "Veuillez noter que ces supports sont destinés uniquement à l'entraînement pour le test IELTS et ne remplacent en aucun cas\n" +
        "            le test IELTS. Guided E-learning n'est pas affilié à l'IELTS et ces supports n'ont pas été préparés par\n" +
        "            l'Université de Cambridge dans le cadre du programme IELTS. Par conséquent, ces supports utilisent un système\n" +
        "            de notation distinct de celui du test IELTS. Les scores que vous obtenez sur ce système peuvent ne pas refléter le score que vous obtiendrez\n" +
        "            au test IELTS. L'étudiant comprend et reconnaît qu'il ne peut pas se fonder sur ces supports pour\n" +
        "            démontrer sa réussite au test IELTS.",
    emptyDashboardTitle: "Commencez votre premier test blanc",
    emptyDashboardDescription: "Entraînez-vous dès aujourd'hui avec des outils conçus pour vous aider à réussir.",
    emptyDashboardActionLabel: "Commencer maintenant"
}
